import DaumblogAttachmentConverter from "../../../../../../lib/attachment/DaumblogAttachmentConverter"

function removeHrStyle(editor, e) {
  const $ = editor.dom.$
  $('hr', e.node).each((idx, elm) => {
    $(elm).attr('style', '')
  })
}

export function daumblogAttachmentSetContent(editor, e) {
  DaumblogAttachmentConverter.convertToEditor(editor, e)
  removeHrStyle(editor, e)
}
